import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/dist/index.css'
import {ElTooltip} from "element-plus";

createApp(App)
  .use(store)
  .use(router)
  .use(ElTooltip)
  // .use(Vue3VideoPlayer, {
  //   lang: 'zh-CN'
  // })
  .mount('#app')
